// Module
var code = "L’opération XXXX est désormais terminée.<br> Le gagnant du tirage au sort sera contacté prochainement par email.";
// Exports
module.exports = code;